import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import type { AnalyticEventData } from '@gonfalon/analytics/types';

const trackObservabilityEvent = createTrackerForCategory('Observability');

export const trackVegaAiPanelOpened = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Panel Opened', properties);

export const trackVegaAiPanelClosed = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Panel Closed', properties);

export const trackVegaAiPromptSent = (requestType: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Prompt Sent', { requestType, ...properties });

export const trackVegaAiModeChanged = (requestType: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Mode Changed', { requestType, ...properties });

export const trackVegaAiSuggestedPromptClicked = (prompt: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Suggested Prompt Clicked', { prompt, ...properties });

export const trackVegaAiConversationShared = (conversationId: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Conversation Shared', { conversationId, ...properties });

export const trackVegaAiConversationCleared = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Conversation Cleared', properties);

export const trackVegaAiConversationLoaded = (conversationId: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Conversation Loaded', { conversationId, ...properties });

export const trackVegaAiGithubConnectClicked = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI GitHub Connect Clicked', properties);

export const trackVegaAiGithubAuthClicked = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI GitHub auth Clicked', properties);

export const trackVegaAiMentionOpened = (properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Mention Opened', properties);

export const trackVegaAiResourceAttached = (resourceType: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Resource Attached', { resourceType, ...properties });

export const trackVegaAiMessageCopied = (messageType: 'vega' | 'user', properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Message Copied', { messageType, ...properties });

export const trackVegaAiConversationCopied = (conversationId?: string, properties: AnalyticEventData = {}) =>
  trackObservabilityEvent('Vega AI Conversation Copied', { conversationId, ...properties });

export const trackVegaCanvasOpened = (properties: { source: 'user' | 'agent'; kind: string; resourceType?: string }) =>
  trackObservabilityEvent('Vega Canvas Opened', properties);

export const trackVegaCanvasRefreshed = (properties: { resourceType: string; outcome: string }) =>
  trackObservabilityEvent('Vega Canvas Refreshed', properties);

export const trackVegaCanvasRefreshDeferred = (properties: { resourceType: string; outcome: string }) =>
  trackObservabilityEvent('Vega Canvas Refresh Deferred', properties);

export const trackVegaAiConversationOpenInObservability = (
  conversationId: string,
  properties: AnalyticEventData = {},
) => trackObservabilityEvent('Vega AI Conversation Open in Observability', { conversationId, ...properties });
